import React from 'react';
import { routePaths } from '../../routePaths';
import { CreateDiscountForm } from '../../modules';
import { EditScreenLayout } from '../../ui-kit';

const NewDiscountView = () => (
    <EditScreenLayout path={routePaths.discounts}>
        <CreateDiscountForm />
    </EditScreenLayout>

);

export default NewDiscountView;
